// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/UnileverShilling.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/UnileverShillingMedium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/UnileverShillingBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/UnileverShillingItalic.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-custom-width {
  max-width: 14.28%;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'Unilever Shilling';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 400;
  font-style: italic;
}

body {
  font-family: 'Unilever Shilling', sans-serif;
  background-color: #eaeaea;
  font-size: 0.875rem;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
  color: inherit;
  font-weight: 900;
}

h1,
.h1 {
  font-size: 2.25rem;
  /* 36px */
}

h2,
.h2 {
  font-size: 1.875rem;
  /* 30px */
}

h2_32,
.h2_32 {
  font-size: 2rem;
  /* 30px */
}

h3,
.h3 {
  font-size: 1.5rem;
  /* 24px */
}

h4,
.h4 {
  font-size: 1.125rem;
  /* 18px */
}

h5,
.h5 {
  font-size: 0.813rem;
  /* 13.008px */
}

h5_400,
.h5_400 {
  font-size: 0.875rem !important;
  font-weight: 400 !important;
  /* 14px */
  /* 13.008px */
}

h6,
.h6 {
  font-size: 1rem;
  /* 16px */
}

h20,
.h20 {
  font-size: 1.25rem !important;
  /* 16px */
}

w600,
.w600 {
  font-weight: 600 !important;
}

w400,
.w400 {
  font-weight: 400 !important;
}

h7_400,
.h7_400 {
  font-size: 0.75rem;
  font-weight: 400;
  /* 12px */
}

.show-empty-badge {
  display: inline-block !important;
  height: 0.938rem;
  width: 2.188rem;
}

.feather {
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
}

/*
   * Navbar
   */

.navbar .form-control {
  padding: 0.75rem 1rem;
  border-width: 0;
  border-radius: 0;
}

.form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.1);
}

.form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 0.188rem rgba(255, 255, 255, 0.25);
}

.box-p-min-height {
  min-height: 4.063rem;
}

.card-body {
  padding: 0.625rem !important;
}

.library-details {
  padding: 20px !important;
}
.accordion-button {
  background-color: #c7c7c7;
}

.accordion-button:focus {
  box-shadow: none;
}

.accordion-button:not(.collapsed) {
  color: #212529;
}

.prompt-playground .small-box {
  background-color: #9c44c0;
  color: #ffffff;
  min-height: 175px;
}
.prompt-playground .error-box {
  background-color: #ec6157;
  color: #ffffff;
  min-height: 175px;
}

.prompt-playground-card-heading {
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: 120%;
  /* 21.6px */
}

.alignDataCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flexColumnSpaceBetween {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flexRowSpaceBetween {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.prompt-playground .card-header {
  padding-left: 10px !important;
}

.blueButton {
  background-color: var(--uni_std_clr);
  color: rgba(255, 255, 255, 1);
  font-size: 0.875rem;
  font-weight: 400;
}

.blueButton:hover {
  background-color: var(--uni_std_clr);
  color: rgba(255, 255, 255, 1);
  font-size: 0.875rem;
  font-weight: 400;
}

.whiteButton {
  font-size: 0.875rem;
  font-weight: 400;
}

.whiteButton:hover {
  background-color: whitesmoke;
}

.noHoverButton:hover {
  background-color: inherit;
  box-shadow: none;
  color: inherit;
}

.noHoverButtonBlue:hover {
  background-color: inherit;
  box-shadow: none;
  color: inherit;
}

.unSelectedButton {
  border-color: #8f9abc4d;
  color: #838fb4;
}

.un_standard_color {
  color: var(--uni_std_clr) !important;
}

.background_blue {
  background-color: var(--background_blue);
}

.borderDetails {
  border: 1px solid var(--border_color);
}

@media (max-width: 1200px) {
  h1 {
    font-size: 36px;
  }
}

@media (max-width: 992px) {
  h1 {
    font-size: 34px;
  }
}

@media (max-width: 768px) {
  h1 {
    font-size: 32px;
  }
}

@media (max-width: 576px) {
  h1 {
    font-size: 30px;
  }
}

.uni-bg-blue {
  background-color: #2435bf;
}

.uni-header {
  display: flex;
  min-height: 130px;
  padding: 3px 12px 3px 12px;
  align-items: center;
  gap: 197px;
}

.uni-brand-text {
  display: flex;
  width: 210px;
  height: 73px;
  flex-direction: column;
  justify-content: center;
}

.uni-header-primary {
  color: #ffffff;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  /* 33.6px */
}

.uni-header-secondary {
  color: #ffffff;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.user-img {
  height: 50px;
  width: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,2DAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2DAAmE;EACnE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,2DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,2BAA2B;EAC3B,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;IAEI;;AAEJ;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":["@import 'bootstrap/dist/css/bootstrap.min.css';\n\n.col-custom-width {\n  max-width: 14.28%;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShilling.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShillingMedium.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShillingBold.woff') format('woff');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Unilever Shilling';\n  src: url('./assets/fonts/UnileverShillingItalic.woff2') format('woff');\n  font-weight: 400;\n  font-style: italic;\n}\n\nbody {\n  font-family: 'Unilever Shilling', sans-serif;\n  background-color: #eaeaea;\n  font-size: 0.875rem;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  line-height: 1.2;\n  color: inherit;\n  font-weight: 900;\n}\n\nh1,\n.h1 {\n  font-size: 2.25rem;\n  /* 36px */\n}\n\nh2,\n.h2 {\n  font-size: 1.875rem;\n  /* 30px */\n}\n\nh2_32,\n.h2_32 {\n  font-size: 2rem;\n  /* 30px */\n}\n\nh3,\n.h3 {\n  font-size: 1.5rem;\n  /* 24px */\n}\n\nh4,\n.h4 {\n  font-size: 1.125rem;\n  /* 18px */\n}\n\nh5,\n.h5 {\n  font-size: 0.813rem;\n  /* 13.008px */\n}\n\nh5_400,\n.h5_400 {\n  font-size: 0.875rem !important;\n  font-weight: 400 !important;\n  /* 14px */\n  /* 13.008px */\n}\n\nh6,\n.h6 {\n  font-size: 1rem;\n  /* 16px */\n}\n\nh20,\n.h20 {\n  font-size: 1.25rem !important;\n  /* 16px */\n}\n\nw600,\n.w600 {\n  font-weight: 600 !important;\n}\n\nw400,\n.w400 {\n  font-weight: 400 !important;\n}\n\nh7_400,\n.h7_400 {\n  font-size: 0.75rem;\n  font-weight: 400;\n  /* 12px */\n}\n\n.show-empty-badge {\n  display: inline-block !important;\n  height: 0.938rem;\n  width: 2.188rem;\n}\n\n.feather {\n  width: 1rem;\n  height: 1rem;\n  vertical-align: text-bottom;\n}\n\n/*\n   * Navbar\n   */\n\n.navbar .form-control {\n  padding: 0.75rem 1rem;\n  border-width: 0;\n  border-radius: 0;\n}\n\n.form-control-dark {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.form-control-dark:focus {\n  border-color: transparent;\n  box-shadow: 0 0 0 0.188rem rgba(255, 255, 255, 0.25);\n}\n\n.box-p-min-height {\n  min-height: 4.063rem;\n}\n\n.card-body {\n  padding: 0.625rem !important;\n}\n\n.library-details {\n  padding: 20px !important;\n}\n.accordion-button {\n  background-color: #c7c7c7;\n}\n\n.accordion-button:focus {\n  box-shadow: none;\n}\n\n.accordion-button:not(.collapsed) {\n  color: #212529;\n}\n\n.prompt-playground .small-box {\n  background-color: #9c44c0;\n  color: #ffffff;\n  min-height: 175px;\n}\n.prompt-playground .error-box {\n  background-color: #ec6157;\n  color: #ffffff;\n  min-height: 175px;\n}\n\n.prompt-playground-card-heading {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 900;\n  line-height: 120%;\n  /* 21.6px */\n}\n\n.alignDataCenter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flexColumnSpaceBetween {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.flexRowSpaceBetween {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.prompt-playground .card-header {\n  padding-left: 10px !important;\n}\n\n.blueButton {\n  background-color: var(--uni_std_clr);\n  color: rgba(255, 255, 255, 1);\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.blueButton:hover {\n  background-color: var(--uni_std_clr);\n  color: rgba(255, 255, 255, 1);\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.whiteButton {\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.whiteButton:hover {\n  background-color: whitesmoke;\n}\n\n.noHoverButton:hover {\n  background-color: inherit;\n  box-shadow: none;\n  color: inherit;\n}\n\n.noHoverButtonBlue:hover {\n  background-color: inherit;\n  box-shadow: none;\n  color: inherit;\n}\n\n.unSelectedButton {\n  border-color: #8f9abc4d;\n  color: #838fb4;\n}\n\n.un_standard_color {\n  color: var(--uni_std_clr) !important;\n}\n\n.background_blue {\n  background-color: var(--background_blue);\n}\n\n.borderDetails {\n  border: 1px solid var(--border_color);\n}\n\n@media (max-width: 1200px) {\n  h1 {\n    font-size: 36px;\n  }\n}\n\n@media (max-width: 992px) {\n  h1 {\n    font-size: 34px;\n  }\n}\n\n@media (max-width: 768px) {\n  h1 {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 576px) {\n  h1 {\n    font-size: 30px;\n  }\n}\n\n.uni-bg-blue {\n  background-color: #2435bf;\n}\n\n.uni-header {\n  display: flex;\n  min-height: 130px;\n  padding: 3px 12px 3px 12px;\n  align-items: center;\n  gap: 197px;\n}\n\n.uni-brand-text {\n  display: flex;\n  width: 210px;\n  height: 73px;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.uni-header-primary {\n  color: #ffffff;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 140%;\n  /* 33.6px */\n}\n\n.uni-header-secondary {\n  color: #ffffff;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n}\n\n.user-img {\n  height: 50px;\n  width: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
